<template>
  <div class="animated fadeIn">
    <CModal
      :show.sync="show"
      :color="errorResponse ? 'danger' : 'dark'"
      :accent-color="errorResponse ? 'danger' : 'success'"
      centered
      >
      <template #header>

        <!-- <h5 class="modal-title">{{ title }}</h5> -->

      <div class="m-auto my-3">
        <img v-if="errorResponse" :src="require('@/assets/img/exclamation-2.svg')" width="80px" alt="Icono error">
        <img v-else :src="require('@/assets/img/check-green.svg')" width="80px" alt="Icono check">
      </div>

        <!-- <CButtonClose @click="$emit('cancel')" class="text-white mr-0"/> -->
      </template>


      <div class="text-center my-3">

        <slot/>

      </div>


      <template #footer >

        <!-- <div class="d-flex justify-content-center align-items-center">
         <button @click="$emit('confirm')" class="btn-login-custom btn">{{ confirmText }}</button>
        </div> -->

        <!-- <CButton @click="$emit('cancel')" color="outline-dark">{{ cancelText }}</CButton> -->
        <CButton @click="$emit('confirm')" :color="errorResponse ? 'danger' : 'primary'">{{ confirmText }}</CButton>
      </template>
    </CModal>

  </div>

</template>

<script>
export default {
  name:'CreditCardResponse',
  props: {
    show: {type: Boolean, default: false },

    title: {type: String, default: 'Confirmar'},

    confirmText: {type: String, default: 'Aceptar'},
    cancelText: {type: String, default: 'Cancelar'},

    errorResponse: {type: Boolean, default: false },
  },
  data() {
    return {
    }
  },
  computed: {

  }

}
</script>
